import Sales from './modules/sales'
import Purchasing from './modules/purchasing'

export { Sales, Purchasing }

export default [
  {
    id: 1,
    label: 'dashboard',
    icon: 'bx bx-home-circle',
    link: '/'
  },
  {
    id: 2,
    label: 'my orders',
    icon: 'bx bx-package',
    link: { name: 'sales.my-orders', force: true }
  },
  {
    id: 3,
    label: 'Statistics',
    icon: 'bx bx-line-chart',
    isUiElement: true,

    subItems: [
      {
        id: 31,
        label: 'sales',
        link: { name: 'stats.sales' },
        parentId: 2
      },
      {
        id: 33,
        label: 'reports',
        link: { name: 'stats.reports' },
        parentId: 2
      },
      {
        id: 32,
        label: 'products',
        link: { name: 'stats.products' },
        parentId: 2
      }
    ]
  }
]
